<template>
  <div class="kfqg">
    <div class="kfqg-title">
      <div>开放强国数据库</div>
      <p>优质资讯 优胜之道</p>
    </div>
    <div class="kfqg-content">
      <p class="content-title">
        基于对改革开放40年的信息内容收集与整合，将一系列与对外开放40年来的与开放型经济强国关联密切的信息数据集成为专业文献数据库。
      </p>
      <div class="content-wrap">
        <img class="wrap-img" src="@/assets/image/gw_kfqg.png" />
        <div class="wrap-info">
          <div class="info-item">
            <div class="item-til">
              <div></div>
              数据收入连续性强
            </div>
            <p class="item-ind">收录内容自1992年至今，是目前国内文献型数据库领域中连续收录年限最完整的数据库之一。</p>
          </div>
          <div class="info-item">
            <div class="item-til">
              <div></div>
              文献收录全面精准
            </div>
            <p class="item-ind">
              目前数据库容量超过1000万篇文献，每日更新数据信息2000万汉字。并且，所有文献经过严格清洗及标引。
            </p>
          </div>
          <div class="info-item">
            <div class="item-til">
              <div></div>
              大数据数字化分析展示
            </div>
            <p class="item-ind">
              十八大以来，数据库结合历史数据通过专项开发实现各类数字化分析展示，为各种理论研究提供数据支持。
            </p>
          </div>
          <div class="info-item">
            <div class="item-til">
              <div></div>
              系统特色
            </div>
            <p class="item-ind">
              数据库数据分析系统，是北京精讯云顿数据软件有限公司以30年来积累的所有信息为内容，整合了各种分析工具的开放式数据分析平台，功能强大，操作简单，容易掌握，不仅能为用户提供系统内嵌的强大的数据资源，而且能够为用户提供趋势分析与建立各种数据建模方法。
            </p>
          </div>
          <div class="info-item">
            <div class="item-til">
              <div></div>
              服务宗旨
            </div>
            <p class="item-ind">
              数据分析系统旨在帮助高端研究人员做基础信息内容的提取，并按照使用者的需求在时间轴里对趋势的发展做判断，帮助高端智库人员提高对政策报告的写作和评判能力。
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {}
  },
  methods: {},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
@import '../../styles/global.less';
.kfqg-title {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 536px;
  background: url(~@/assets/image/back_kfqg.png) center no-repeat;
  background-size: 100% 100%;
  div {
    margin: 48px 0;
    font-size: 48px;
    font-weight: 600;
    color: #ffffff;
  }
  p {
    font-size: 24px;
    font-weight: 400;
    color: #ffffff;
    line-height: 28px;
  }
}
.kfqg-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 80%;
  margin: 64px auto;
  .content-title {
    margin: 0 0 64px;
    font-size: 20px;
    font-weight: 400;
    color: #333333;
    line-height: 40px;
  }
  .content-wrap {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    width: 100%;
    .wrap-img {
      max-width: 50%;
    }
    .wrap-info {
      width: 45%;
      .info-item {
        padding: 24px 40px;
        margin: 32px 0;
        background: #ffffff;
        border-radius: 10px;
        box-shadow: 0px 0px 16px 0px #cfd8eb;
        .item-til {
          position: relative;
          font-size: 24px;
          font-weight: 600;
          color: #333333;
          div {
            position: absolute;
            bottom: -5px;
            left: 0;
            width: 50px;
            height: 20px;
            opacity: 0.3;
            background: #0377ff;
            border-radius: 10px;
          }
        }
        .item-ind {
          margin: 24px 0;
          font-size: 16px;
          font-weight: 400;
          color: #656565;
        }
      }
    }
  }
}
</style>
